import { css, styled } from 'styled-components'

import { OutbidLabel } from '../OutbidLabel/OutbidLabel'
import { WinningBid } from '../WinningBid/WinningBid'

export const StyledOutbidLabel = styled(OutbidLabel)`
  ${({ theme }) => css`
    color: ${theme.colours.status.error};
  `}
`

export const StyledWinningBid = styled(WinningBid)`
  ${({ theme }) => css`
    color: ${theme.colours.status.success};
    margin-bottom: 15px;
  `}
`
